import { render, staticRenderFns } from "./skuEdit.vue?vue&type=template&id=3eea8580&scoped=true"
import script from "./skuEdit.vue?vue&type=script&lang=js"
export * from "./skuEdit.vue?vue&type=script&lang=js"
import style0 from "./skuEdit.vue?vue&type=style&index=0&id=3eea8580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eea8580",
  null
  
)

export default component.exports